module.exports = __webpack_public_path__ + "img/citrus_long.8c7403de.svg";